export const CUSTOM_PRODUCT_ID = 'CUSTOM' as const;
export const CUSTOM_PRODUCT_NAME = 'Personalizado' as const;
export const CUSTOM_PRODUCT_MEASUREMENT_UNIT = 'm³' as const;

export const VALIDATION_ERROR_MESSAGES = {
  NOT_AVAILABLE:
    'Esta combinación no está disponible. Por favor, intente con otras opciones.',
  GENERAL_ERROR: 'Error al validar la combinación. Intente nuevamente.',
  LOAD_CONFIG_ERROR:
    'Error al cargar la configuración personalizada para edición.',
} as const;

export const HTTP_STATUS_NOT_FOUND = 404 as const;
